import CampaignModel from 'cio/models/campaign';
import { TransformsList } from 'cio/utils/analytics/transforms';
import campaignTransforms from 'cio/utils/analytics/transforms/campaign';

const Transforms: TransformsList = {
  generateBaseData({ data }) {
    let eventData: Record<string, any> = {};
    if (data.campaign !== undefined) {
      // Base campaign details
      eventData = campaignTransforms.base({
        model: data.campaign,
      });

      // Object type details from campaign
      let campaign = data.campaign as CampaignModel;
      let objectType = campaign?.objectTypeForCampaign;
      data.objectTypeName = objectType?.name;
      data.objectTypeID = objectType?.id;
    }

    // Per https://www.notion.so/custio/Mixpanel-for-AI-Experimental-Features-1e2d57b9342d4b24b2084c9ee4f36ca9
    // also want to include: Workspace ID, Message ID. I don't see those
    // for other Mixpanel events, so leaving for now.
    return {
      Channel: data.channel,
      'Object Type ID': data.objectTypeID,
      'Object Type Name': data.objectTypeName,
      'Requested Adjustment': data.adjustment,
      ...eventData,
    };
  },
};

export default Transforms;
